import React from "react";
import { Link } from "react-router-dom";
import { sendDataLayer } from "../../utils/functions";
import Icon from "../../components/atoms/Icon";
import useWidth from '../../hooks/useWidth'

function Footer({
  footerType,
  links,
  // linksText,
  content,
  logOutAction,
  loggedIn,
}) {
  const { width } = useWidth();
  const closeSession = (e) => {
    logOutAction()
    sendDataLayer({datalayer: {event: "footer",text: e.target.textContent,link: window.location.href},repeat: true})
  }
  const handler = (e, link) => {
    link.onClick()
    sendDataLayer({
      datalayer: {
        event: "footer",
        text: e.target.textContent,
        link: link.link,
      },
      repeat: true,
    });
  }

  const handlerA = (e, link) => {
    e.preventDefault();
    sendDataLayer({
      datalayer: {
        event: "footer",
        text: e.target.textContent,
        link: link,
      },
      repeat: true,
    });

    setTimeout(() => {
      window.open(link, "_blank", "noreferrer");
    }, 300);
  }
  return (
    <div
      className={`mc-footer-container mc-footer-container-type-${footerType}`}
    >
      {footerType === 1 && (
        <div className="mc-footer-container__bg">
          <div className="mc-footer-container__section">
            {links && links[0] && (
              <ul className="mc-footer-container__section--links">
                {links.map((link, index) => {
                  return (
                    <Link
                      onClick={(e) => {
                        handler(e, link)
                      }}
                      key={index}
                    >
                      {link.text}
                    </Link>
                  );
                })}
              </ul>
            )}

            {window.location.pathname === '/' &&
              <div className="mc-footer-container__tarjetas">
                <img src="/assets/images/tarjetas.png" alt="tarjetasBogota"/>
              </div>
            }
            
            <div className="mc-footer-container__text" dangerouslySetInnerHTML={{ __html: content }} />
            <hr></hr>
            <div className="mc-footer-container__text"><p>Si no recibiste invitación por correo o SMS, esta campaña no aplica para ti, pero no te preocupes, aún tienes acceso a todos los beneficios que Mastercard tiene para ofrecerte. <a href="https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html" target="_blank" rel="noreferrer">Conoce los beneficios y disfrútalos.</a></p></div>
            <div className="mc-footer-container__imgs">
              <a href="https://www.youtube.com/user/BancodeBogota" onClick={(e) => {handlerA(e, 'https://www.youtube.com/user/BancodeBogota')}}><img src="/assets/images/youtube.svg" alt="logo youtube"/></a>
              <a href="https://www.instagram.com/bancodebogota/" onClick={(e) => {handlerA(e, 'https://www.instagram.com/bancodebogota/')}}><img src="/assets/images/instagram.svg" alt="logo instagram"/></a>
              <a href="https://www.linkedin.com/company/banco-de-bogota/" onClick={(e) => {handlerA(e,'https://www.linkedin.com/company/banco-de-bogota/')}}><img src="/assets/images/linkedin.svg" alt="logo linkedIn"/></a>
              <a href="https://www.facebook.com/BancodeBogota/" onClick={(e) => {handlerA(e, 'https://www.facebook.com/BancodeBogota/')}}><img src="/assets/images/facebook.svg" alt="logo facebook"/></a>
              <a href="https://x.com/bancodebogota" onClick={(e) => {handlerA(e, 'https://x.com/bancodebogota')}}><img src="/assets/images/twitter.svg" alt="logo twitter"/></a>
              <a href="https://api.whatsapp.com/send?phone=573182814679&text=Hola,%20%C2%BFC%C3%B3mo%20me%20puedes%20ayudar?" onClick={(e) => {handlerA(e, 'https://api.whatsapp.com/send?phone=573182814679&text=Hola,%20%C2%BFC%C3%B3mo%20me%20puedes%20ayudar?')}}><img src="/assets/images/whatsapp.svg" alt="logo whatsapp"/></a>
            </div>
            <ul className="mc-footer-container__section--banca">
              {width > 992
              ? <>
                  <a href="https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app')}}>
                    Banca App <Icon name='banca-app' />
                  </a>
                  <a href="https://www.bancodebogota.com/empresas" onClick={(e) => {handlerA(e, 'https://www.bancodebogota.com/empresas')}}>
                    <Icon name='banca-virtual' /> Banca Virtual
                  </a>
                  <a href="https://virtual.bancodebogota.co/" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/')}}>
                    Zona transaccional
                  </a>
                </>

              : <>
                  <a href="https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app')}}>
                    Banca App <Icon name='banca-app' />
                  </a>
                  <a href="https://www.bancodebogota.com/empresas" onClick={(e) => {handlerA(e, 'https://www.bancodebogota.com/empresas')}}>
                    <Icon name='banca-virtual' /> Banca Virtual
                  </a>
                </>
              }
            </ul>
            {width <= 992 &&
              <div className="transaccional">
                <a href="https://virtual.bancodebogota.co/" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/')}}>
                  Zona transaccional
                </a>
              </div>
            }
            {loggedIn &&
              <>
                <hr></hr>
                <div className="mc-footer-close" onClick={closeSession}>
                  <span>
                    Salir <Icon name='close_session' />
                  </span>
                </div>
              </>
            }
          </div>
          <div className="mc-footer-container__final">
            <img src="/assets/images/logo_bdb.png" alt="Logo BdB"/>
            <img src="/assets/images/logo_mc_white.png" alt="Logo MC"/>
            <span>Todos los derechos  reservados</span>
          </div>
          <img src="/assets/images/vigilado.svg" alt="Logo Vigilado" className="vigilado"/>
        </div>
      )}
    </div>
  );
}

export default Footer;
